import { render } from "./AposPager.vue?vue&type=template&id=70b89ed5&scoped=true"
import script from "./AposPager.vue?vue&type=script&lang=js"
export * from "./AposPager.vue?vue&type=script&lang=js"

import "./AposPager.vue?vue&type=style&index=0&id=70b89ed5&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b89ed5"],['__file',"ui/ui/apos/components/AposPager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70b89ed5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70b89ed5', __exports__)) {
    api.reload('70b89ed5', __exports__)
  }
  
  module.hot.accept("./AposPager.vue?vue&type=template&id=70b89ed5&scoped=true", () => {
    api.rerender('70b89ed5', render)
  })

}


export default __exports__